import { render, staticRenderFns } from "./NoticePanel.vue?vue&type=template&id=2bd10b08&scoped=true&"
import script from "./NoticePanel.vue?vue&type=script&lang=js&"
export * from "./NoticePanel.vue?vue&type=script&lang=js&"
import style0 from "./NoticePanel.vue?vue&type=style&index=0&id=2bd10b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd10b08",
  null
  
)

export default component.exports